const AUTH_STORAGE_KEYS = [
    'token',
    'userEmail',
    'userRole',
    'mustChangePassword',
    'assignedProducts',
    'selectedProduct'
];

export const clearAuthStorage = () => {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const persistAuthSession = ({ token, user }) => {
    if (token) {
        localStorage.setItem('token', token);
    }

    if (user) {
        localStorage.setItem('userEmail', user.email || '');
        localStorage.setItem('userRole', user.role || '');
        localStorage.setItem('userId', String(user.id || ''));
        localStorage.setItem('assignedProducts', JSON.stringify(user.assignedProducts || []));
        localStorage.setItem('mustChangePassword', String(Boolean(user.mustChangePassword)));
    }
};

export const getStoredToken = () => localStorage.getItem('token');

export const getStoredRole = () => localStorage.getItem('userRole');

export const getStoredUserId = () => localStorage.getItem('userId');

export const getMustChangePassword = () => localStorage.getItem('mustChangePassword') === 'true';

export const hasStoredSession = () => Boolean(getStoredToken());
